/**
 * Copyright (c) 2018
 * @summary  Domain Element boxes Loop
 * @author Mangesh Pimprikar,Ankur Vishwakarma,Poonam Banode,Irfan Bagwan
 *
 */
import React, { Component } from 'react';
import { isFirefox, isIE } from 'react-device-detect';
import { NavLink } from 'react-router-dom';
import cx from 'classnames';
import { isFunction } from 'lodash/lang';

import { ItemGroupApi } from '../../../../../api';
import NewEncounterLogCheckApi from '../../../../../api/patient/NewEncounterLogCheckApi';
import Checkbox from '../../../../../common/data-entry/InputSelectors/Checkbox';
import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Icon from '../../../../../common/general/Icon';
import useMobileDevice from '../../../../../common/hooks/useMobileDevice';
import NotificationManager from '../../../../../common/notifications/NotificationManager';
import { LOG_CHECKS_ADDED } from '../../../../../constants/notificationMessages';
import { CLOSED } from '../../../../../constants/ssuStatuses';
import {
  scGray15,
  scGray70,
  scGreen100,
  scPurple80,
  scRed100,
  scYellow100
} from '../../../../../constants/systemColors';
import { MANAGE_UNEXPECTED_ENCOUNTER_DATA } from '../../../../../constants/userOperations';
import {
  ROLE_CLINICAL_QUALITY_COORDINATOR,
  ROLE_FINANCE_ADMINISTRATOR,
  ROLE_FINANCE_ANALYST,
  ROLE_OPERATION_MANAGER,
  ROLE_OPERATIONS_ANALYST,
  ROLE_PATIENT_REPRESENTATIVE,
  ROLE_PRINCIPAL_INVESTIGATOR,
  ROLE_SITE_COORDINATOR,
  ROLE_STUDY_LEAD,
  ROLE_STUDY_MANAGER,
  ROLE_SUB_INVESTIGATOR,
  ROLE_SYSTEM_ADMINISTRATOR
} from '../../../../../constants/userRoles';
import { userHasAccessTo, userHasRole } from '../../../../../services/auth';
import { onRequestDefaultError, onRequestError } from '../../../../../services/handlers';
import { generateUrlByKey, withCurrentRoute } from '../../../../root/router';
import { withParams } from '../../../../root/router/legacyComponentCompatability';
import { ALLOW_READ, DENY_ALL } from '../../../setup/Protocol/ProtocolSetup/ProtocolGroupsSetup/permissionType';
import DndPopup from '../EncounterDescNew/DndPopup/DndPopup';
import { getItemGroupIcon, getRouteKey } from '../NewEncounterPage/NewEncounterPageService';
import { getIconSuit } from '../Review/reviewService';

import NotPerformedLogCheckReasonModal from './LogCheck/NotPerformedLogCheckReason/NotPerformedLogCheckReasonModal';

import './ItemGroup.scss';

class ItemGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hideEncounterBlock: false,
      notPerformed: false,
      showEncounterStart: []
    };
    this.showEncounterStart = [];
  }

  componentDidMount() {
    const notPerformed = this.props.encounter.skipped === 1;
    const hideEncounterBlock = this.props.encounter.skipped === 1;
    this.showEncounterStart = this.props.encounter.completionRange && this.props.encounter.completionRange.split('/');

    this.setState({
      notPerformed,
      hideEncounterBlock,
      showEncounterStart: this.showEncounterStart,
      isCommentItemGroup: this.props.encounter.elementName === 'Comments'
    });
  }

  setItemGroupNotPerformedStatus = (data, modalBox) => {
    ItemGroupApi.setItemGroupNotPerformedStatus(data).then(() => {
      modalBox.close();
      this.setState({ hideEncounterBlock: !this.state.hideEncounterBlock }, () => {
        this.setState({
          notPerformed: true,
          informedConsentFormId: this.props?.encounter?.informedConsentTemplate?.id
        });
      });

      this.props.loadEncounterDetailData(false);
    }, onRequestError);
  };

  setItemGroupPerformedStatus = data => {
    ItemGroupApi.setItemGroupPerformedStatus(data).then(() => {
      this.setState({ hideEncounterBlock: !this.state.hideEncounterBlock }, () => {
        this.setState({
          notPerformed: false
        });
      });

      this.props.loadEncounterDetailData(true);
    }, onRequestDefaultError);
  };

  hideEncounterDetailBox = notPerformed => {
    if (!notPerformed) {
      const modalBox = ModalBoxes.open({
        title: `Reason ${this.props.encounter.elementName ? this.props.encounter.elementName : 'Procedure'} was not ${
          this.props.encounter.elementType === 'ICF' ? 'applicable' : 'performed'
        }`,
        component: (
          <DndPopup
            onSave={data => {
              const setItemGroupNotPerformedStatusRequest = {
                ssuPatientId: this.props?.encounter?.sitePatientIdentifier,
                ssuPatientEncounterId: this.props?.encounter?.patientEncounterId,
                itemGroupId: this.props?.encounter?.formUniqueIdentifier,
                reason: data.comment ? data.comment.trim() : '',
                informedConsentFormId: this.props?.informedConsentForm?.id
              };
              this.setItemGroupNotPerformedStatus(setItemGroupNotPerformedStatusRequest, modalBox);
            }}
          />
        )
      });
    } else {
      const setItemGroupPerformedStatusRequest = {
        ssuPatientId: this.props?.encounter?.sitePatientIdentifier,
        ssuPatientEncounterId: this.props?.encounter?.patientEncounterId,
        itemGroupId: this.props?.encounter?.formUniqueIdentifier
      };
      this.setItemGroupPerformedStatus(setItemGroupPerformedStatusRequest);
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.encounter !== this.props.encounter) {
      this.showEncounterStart = nextProps.encounter.completionRange && nextProps.encounter.completionRange.split('/');
      this.setState({
        showEncounterStart: this.showEncounterStart
      });
    }

    if (nextProps.encounter.skipped !== this.props.encounter.skipped) {
      this.setState({
        hideEncounterBlock: nextProps.encounter.skipped === 1,
        notPerformed: nextProps.encounter.skipped === 1
      });
    }
  }

  render({ props, state } = this) {
    const iconStyle = this.getIconStyle();
    const boxStyle = {};
    let itemSelected = false;
    const isUnexpected = props.unexpectedEncounter;
    const isAssignedToUnexpectedEncounter =
      props.encounter.formUniqueIdentifier !== 'N/A' || props.encounter.elementName === 'Comments';

    if (isUnexpected && !isAssignedToUnexpectedEncounter) {
      boxStyle.border = '1px #e5e5e5 dashed';
      iconStyle.opacity = '0.3';
    } else {
      boxStyle.border = `1px ${scGray15} solid`;
    }

    if (this.props.selectedItemGroups && this.props.selectedItemGroups.length > 0) {
      const itemGroupIndex = this.props.selectedItemGroups.indexOf(this.props.encounter);
      if (
        itemGroupIndex !== -1 &&
        (userHasRole(ROLE_SYSTEM_ADMINISTRATOR) ||
          (this.props?.currentPatient?.studySiteStatus !== CLOSED && userHasAccessTo(MANAGE_UNEXPECTED_ENCOUNTER_DATA)))
      ) {
        iconStyle.opacity = '1';
        boxStyle.border = '1px #00b1dc solid';
        itemSelected = true;
      }
    }

    let itemGroupContent;
    if (isUnexpected && !isAssignedToUnexpectedEncounter) {
      itemGroupContent = this.getItemGroupContentThatCanBeAdded(isUnexpected, iconStyle, itemSelected);
    } else {
      itemGroupContent = this.getItemGroupContentAdded(iconStyle);
    }

    return (
      // eslint-disable-next-line react-hooks/rules-of-hooks
      <div className={cx('encounter-item-group', { mobile: useMobileDevice(), selected: this.props.isSelected })}>
        {itemGroupContent}
      </div>
    );
  }

  getItemGroupContentThatCanBeAdded(isUnexpected, iconStyle, itemSelected) {
    return (
      <div
        className={'add-item-group'}
        onClick={event => {
          event.preventDefault();
          this.props.addItemGroup(event, isUnexpected, this.props.encounter);
        }}
      >
        {(userHasRole(ROLE_SYSTEM_ADMINISTRATOR) ||
          (this.props?.currentPatient?.studySiteStatus !== CLOSED &&
            userHasAccessTo(MANAGE_UNEXPECTED_ENCOUNTER_DATA))) && (
          <Checkbox className="select-checkbox m-0 ml-3" checked={itemSelected} />
        )}
        {this.getImageWithDescription(iconStyle)}
      </div>
    );
  }

  getIconStyle() {
    let gradientPercentage;
    if (this.props.encounter.completePercentage === 'NaN' || this.props.encounter.completePercentage === '') {
      gradientPercentage = 0;
    } else {
      gradientPercentage = Number(this.props.encounter.completePercentage);
    }
    const gradientValue = `bottom, #691e44 ${gradientPercentage}%, #928d94 ${gradientPercentage}%`;

    if (isIE) {
      return { background: `-ms-linear-gradient(${gradientValue})` };
    }
    if (isFirefox) {
      return { background: `-moz-linear-gradient(${gradientValue})` };
    }
    return { background: `-webkit-linear-gradient(${gradientValue})` };
  }

  getRemoveButton() {
    if (this.props.isAbleToEditEncounter && !this.props.isAbleToEditEncounter()) {
      return;
    }

    const itemGroups = this.props.unExpectedEncounterData.encounterDetailsList;
    const assignedItemGroups = itemGroups.filter(e => {
      return e.formUniqueIdentifier !== 'N/A' && e.elementName !== 'Comments';
    });
    const assignedMoreThanOneItemGroups = assignedItemGroups.length > 1;
    const isAbleToDelete =
      assignedMoreThanOneItemGroups &&
      this.props.encounter.completePercentage &&
      parseFloat(this.props.encounter.completePercentage) === 0 &&
      this.props.unexpectedEncounter &&
      !this.state.isCommentItemGroup;
    if (isAbleToDelete && userHasAccessTo(MANAGE_UNEXPECTED_ENCOUNTER_DATA)) {
      return (
        <span
          onClick={() => this.props.removeItemGroup(this.props.encounter)}
          className="right-corner-button remove-button material-icons"
        >
          cancel
        </span>
      );
    }
  }

  onClickNotPerformed = event => {
    if (!userHasRole([ROLE_STUDY_LEAD])) {
      return this.state.showEncounterStart && parseInt(this.state.showEncounterStart[0], 10)
        ? ''
        : this.hideEncounterDetailBox(this.state.notPerformed, event);
    }
  };

  onClickLogCheckNotPerformed = () => {
    const notPerformedLogCheckReasonModal = ModalBoxes.open({
      component: (
        <NotPerformedLogCheckReasonModal
          onSave={comment => {
            const request = { reason: comment };
            NewEncounterLogCheckApi.saveLogCheckNotPerformed(
              this.props.encounter?.sitePatientIdentifier,
              this.props.encounter?.patientEncounterId,
              this.props.encounter?.formUniqueIdentifier,
              this.props.encounter?.studySiteIdentifier,
              request
            )
              .then(() => {
                NotificationManager.success(LOG_CHECKS_ADDED);
                isFunction(this.props.loadEncounterDetailData) && this.props.loadEncounterDetailData();
              })
              .catch(err => NotificationManager.error(err.response.data.message));
            notPerformedLogCheckReasonModal.close();
          }}
          itemGroupName={this.props.encounter?.elementName}
        />
      ),
      title: `Reason ${this.props.encounter?.elementName} was not performed`
    });
  };

  getItemGroupContentAdded(iconStyle) {
    let imageWithDescription = this.getImageWithDescription(iconStyle);
    if (!(this.state.isCommentItemGroup && this.props.encounter.formUniqueIdentifier === 'N/A')) {
      imageWithDescription = this.wrapWithNavigation(imageWithDescription);
    }

    return (
      <React.Fragment>
        <>
          {imageWithDescription}
          {this.getRemoveButton()}
          {this.getNotPerformedButton()}
        </>
      </React.Fragment>
    );
  }

  getImageWithDescription() {
    const { props } = this;
    let completionRangeStyle;
    let elementNameStyle;
    if (props.encounter.formUniqueIdentifier === 'N/A') {
      completionRangeStyle = { color: '#7d7d7d' };
      elementNameStyle = { color: '#616161' };
    }

    const itemGroupName = props.encounter.elementName ? props.encounter.elementName : '--';
    let backgroundColor = '';
    let a = parseInt(props.encounter.completePercentage);
    if (a === 0 && !props.encounter.skipped) {
      backgroundColor = scPurple80;
    } else if (a > 0 && a < 100) {
      backgroundColor = scYellow100;
    } else if (a === 100 || props.encounter.skipped) {
      backgroundColor = scGreen100;
    }
    const showProgressData = props.encounter.elementType !== 'Logs' && props.encounter.domainCode !== 'CO';
    return (
      <div
        className={cx('details-container', {})}
        style={{
          color: scGray70
        }}
      >
        <Icon suit={getIconSuit(props.encounter.elementType)}>{getItemGroupIcon(props.encounter)}</Icon>
        <div className="p-2">
          <h6 className="item-group-name" style={elementNameStyle} title={props.encounter.elementName}>
            {itemGroupName}
            {props.isNewIcfForm && (
              <strong className={'ml-1'} style={{ color: scRed100 }}>
                NEW
              </strong>
            )}
          </h6>
          {props.encounter.formUniqueIdentifier !== 'N/A' && props.encounter.domainCode !== 'CO' && (
            <span
              style={{ backgroundColor, width: '40px', height: '10px', display: 'inline-block' }}
              className={'mr-2'}
            />
          )}
          {showProgressData && !this.state.notPerformed && (
            <span style={completionRangeStyle}>{props.encounter.completionRange}</span>
          )}
          {showProgressData && this.state.notPerformed && (
            <span>{props.encounter.domainCode === 'ICF' ? 'Not Applicable' : 'Not Performed'}</span>
          )}
          {props.encounter.elementType === 'Logs' && props.encounter.domainCode !== 'CO' && (
            <span>{props.encounter.logCheckSignatureType || '0/1'}</span>
          )}
        </div>
      </div>
    );
  }

  static buildItemGroupIconPath(itemGroupType) {
    if (!itemGroupType) {
      return 'no-image';
    }
    return itemGroupType.toLowerCase().replace(/\s/g, '-');
  }

  showNotPerformedBtnForLogsItemGroup() {
    const isLogType = this.props.encounter.elementType === 'Logs';
    const isItemGroupNotPerformed = this.state.hideEncounterBlock;
    return isLogType && isItemGroupNotPerformed;
  }

  getNotPerformedButton() {
    const isRegular = !(this.props.unexpectedEncounter || this.props.unExpectedEncounterData.isUnexpected);
    const isMandatoryItemGroup = !this.state.isCommentItemGroup;

    const isLogType = this.props.encounter.elementType === 'Logs';
    const showNpButton =
      (isRegular && isMandatoryItemGroup) || !isLogType || this.showNotPerformedBtnForLogsItemGroup();
    if (showNpButton) {
      const hideClass = `${this.state.hideEncounterBlock ? 'e-hide' : ''}`;
      const shouldHideElementBeApplied =
        this.state.showEncounterStart && parseInt(this.state.showEncounterStart[0], 10) > 0;
      const hideElementClass = `${shouldHideElementBeApplied ? 'hide-element' : ''}`;
      const isNpEnabled =
        this.props.encounter.logCheckTemplate?.rows?.some(e => e.rowType === 'NOT_PERFORMED' && e.checked) ||
        !isLogType;
      return (
        isNpEnabled && (
          <span className="right-corner-button eye-icon">
            <button
              type="button"
              disabled={
                isLogType
                  ? this.isLogCheckNotPerformedButtonDisabled()
                  : this.isItemGroupNotPerformedButtonDisabled(isLogType)
              }
              className={`btn ${hideClass} ${hideElementClass}`}
              onClick={isLogType ? this.onClickLogCheckNotPerformed : this.onClickNotPerformed}
            >
              {this.props.encounter.elementType === 'ICF' ? 'NA' : 'NP'}
            </button>
          </span>
        )
      );
    }
    return <span style={{ height: '18px', display: 'inline-block' }} />;
  }

  isLogCheckNotPerformedButtonDisabled() {
    return (
      !userHasRole([
        ROLE_STUDY_MANAGER,
        ROLE_PRINCIPAL_INVESTIGATOR,
        ROLE_SUB_INVESTIGATOR,
        ROLE_SYSTEM_ADMINISTRATOR,
        ROLE_PATIENT_REPRESENTATIVE
      ]) ||
      'Not Performed' === this.props.encounter.logCheckSignatureType ||
      this.props.encounter?.permissionType === ALLOW_READ
    );
  }

  isItemGroupNotPerformedButtonDisabled(isLogType) {
    return (
      userHasRole([
        ROLE_STUDY_LEAD,
        ROLE_FINANCE_ANALYST,
        ROLE_FINANCE_ADMINISTRATOR,
        ROLE_OPERATIONS_ANALYST,
        ROLE_CLINICAL_QUALITY_COORDINATOR,
        ROLE_OPERATION_MANAGER,
        ROLE_SITE_COORDINATOR
      ]) ||
      this.props.disabled ||
      isLogType ||
      this.props.encounter?.permissionType === DENY_ALL ||
      this.props.encounter?.permissionType === ALLOW_READ
    );
  }

  wrapWithNavigation(imageWithDescription) {
    const { patientId, ssuPatientId, patientEncounterId } = this.props.params;

    //If Create or Edit Unexpected Encounter
    if (!patientEncounterId) {
      return imageWithDescription;
    }

    const routeKey = this.props.currentRoute.parent.key.includes('Encounter Details')
      ? this.props.currentRoute.parent.key
      : this.props.currentRoute.parent.key + '.Encounter Details';
    return this.props.disabled || this.props.encounter?.permissionType === DENY_ALL ? (
      <div style={{ cursor: 'not-allowed', display: 'flex', flexGrow: 1, filter: 'grayscale(.7)', opacity: '.7' }}>
        {imageWithDescription}
      </div>
    ) : (
      <NavLink
        to={generateUrlByKey(getRouteKey(routeKey, this.props.encounter), {
          patientId,
          ssuPatientId,
          patientEncounterId,
          patientItemGroupId: this.props.encounter.formUniqueIdentifier,
          typeId: this.props.encounter?.informedConsentTemplate?.typeId,
          languageId: this.props.encounter?.informedConsentTemplate?.languageId
        })}
      >
        {imageWithDescription}
      </NavLink>
    );
  }
}

export default withCurrentRoute(withParams(ItemGroup));
